import { QuestionBase, QuestionOptions } from './base.question.class'

interface TextQuestionOptions extends QuestionOptions<string> {
  type?: string
}

export class Question extends QuestionBase<string> {
  controlType = 'input'

  constructor(options: TextQuestionOptions = {}) {
    super(options)
    this.type = options['type'] || 'text'
  }
}
